import { SignIn, SignUp } from '@clerk/clerk-react';
import { useLocation } from 'react-router-dom';

const clerkAppearance = {
  elements: {
    rootBox: 'w-full',
    cardBox: 'w-full',
    card: 'w-full shadow-none border-0 bg-transparent p-0',
    headerTitle: 'hidden',
    headerSubtitle: 'hidden',
    socialButtonsBlockButton: 'h-11 bg-white border border-border hover:bg-muted text-foreground',
    formButtonPrimary: 'h-11 bg-primary hover:bg-primary/90 text-primary-foreground shadow-none',
    formFieldInput: 'h-11 border-border shadow-none',
    formFieldLabel: 'text-sm font-medium text-foreground',
    footerActionLink: 'text-primary hover:text-primary/80',
    dividerLine: 'bg-border',
    dividerText: 'text-muted-foreground',
    formResendCodeLink: 'text-primary hover:text-primary/80',
    identityPreviewEditButton: 'text-primary hover:text-primary/80',
  },
};

export function LoginPage() {
  const location = useLocation();
  const isSignUp = location.pathname.includes('sign-up');

  return (
    <div className="animate-fade-in" data-testid="auth-page">
      <div className="rounded-3xl border border-border bg-card/80 backdrop-blur-sm p-6 sm:p-8 shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-foreground mb-2">
          {isSignUp ? 'Create your account' : 'Welcome back'}
        </h1>
        <p className="text-muted-foreground">
          {isSignUp
            ? 'Get started with Mind Your Waste OPS'
            : 'Sign in to access the operations platform'}
        </p>
      </div>

      {isSignUp ? (
        <SignUp
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          fallbackRedirectUrl="/dashboard"
          appearance={clerkAppearance}
        />
      ) : (
        <SignIn
          routing="path"
          path="/sign-in"
          signUpUrl="/sign-up"
          fallbackRedirectUrl="/dashboard"
          appearance={clerkAppearance}
        />
      )}
      </div>
    </div>
  );
}
